<template>
  <div>
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1050">
      <material-card
        :title="formTitle"
        :icon="formIcon"
        :color="$vuetify.theme.themes.light.success"
        v-if="item"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fluid>
              <v-row>
                <v-col>
                  <trans-textbox
                    v-model="item"
                    field="Name"
                    :label="$t('globals.name')"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-textbox>
                </v-col>
                <v-col v-for="lang in languages" :key="lang.language">
                  <image-uploader-string
                    @image-data="
                      item.Translations.filter(
                        (o) => o.LanguageCode == lang.language
                      )[0].LogoBase64 = $event;
                      $forceUpdate();
                    "
                    :image.sync="
                      item.Translations.filter(
                        (o) => o.LanguageCode == lang.language
                      )[0].LogoBase64
                    "
                    :label="$t('components.portal.portal_settings.logo_{0}', [lang.language])"
                    :rules="[$rules.required]"
                    class="required"
                  ></image-uploader-string>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            :loading="saving"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <material-card
      :title="$t('components.vuematerialdashboard.core.appbar.underwriters')"
      :color="$vuetify.theme.themes.light.primary"
      icon="mdi-scale-balance"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        fileNamePrefix="underwriters"
        identifier="underwritersTable"
        @error="error = $event"
        :showSelect="false"
        :floatActions="floatActions"
      ></pbas-data-table>
    </material-card>
    <v-snackbar v-model="snackbar" color="success" :timeout="2500">
      {{ $t("globals.success") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import getHeaders from "../headers/Underwriters";
import { translate2 } from "../trans2";
import TransTextbox from "@/components/TransTextbox.vue";
import ImageUploaderString from "@/components/ImageUploaderString";
export default {
  components: {
    TransTextbox,
    ErrorHandler,
    ImageUploaderString,
  },
  data() {
    return {
      item: null,
      snackbar: false,
      valid: false,
      provider: undefined,
      saving: false,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.isNew=false;
            this.dialogs.edit = true;
            this.item = JSON.parse(JSON.stringify(item));
          },
        },
      ],
      floatActions: [
        {
          text: "globals.add",
          color: "#64ba5f",
          name: "add",
          icon: "add",
          handler: () => {
            const translations = [];
            for (let lang of this.languages) {
              console.log(lang);
              translations.push({
                LanguageCode: lang.language
              });
            }
            this.item = {
              Translations: translations
            };
            this.dialogs.edit = true;
            this.isNew = true;
          },
        },
      ],
      dialogs: {
        edit: false,
      },
      error: null,
      isNew: false
    };
  },
  computed: {
    ...mapGetters("common", ["languages"]),
    formTitle() {
      return this.isNew
        ? this.$t("views.underwriters.add_title")
        : this.$t("views.underwriters.edit_title");
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
  },
  mounted() {
    this.provider = new PbasOData(
      this.$axiosHttp,
      "underwriters",
      getHeaders()
    );
  },
  methods: {
    ...mapActions("claims", ["addUnderwriter", "updateUnderwriter"]),
    trans(item, field) {
      return translate2(item, field);
    },
    close() {
      this.dialogs.edit = false;
      this.item = null;
    },
    save() {
      let item = JSON.parse(JSON.stringify(this.item));
      item.Name = translate2(item, "Name");
      item.LogoBase64 = translate2(item, "LogoBase64");
      if (this.isNew) {
        this.add(item);
      } else {
        this.update(item);
      }
    },
    async add(item) {
      this.saving = true;
      try {
        await this.addUnderwriter({
          payload: item,
        });
        this.snackbar = true;
        this.close();
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async update(item) {
      this.saving = true;
      try {
        await this.updateUnderwriter({
          id: item.Id,
          payload: item,
        });
        this.snackbar = true;
        this.close();
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
